import React from "react"
import Image from "next/image"
import styled from "styled-components"
import { themeGet } from "@styled-system/theme-get"
import DownloadIcon from "@mui/icons-material/Download"
import { useTranslation } from "next-i18next"

export default function AssetCard({ title, src, fileSrc }) {
  const { t } = useTranslation("common")
  return (
    <CardWrapper className="cardWrapper">
      <div>
        <div className="imgWrapper">
          <Image
            className="img asset"
            alt={title}
            src={src}
            fill
            sizes="100vw"
            style={{
              objectFit: "cover"
            }}
          />
        </div>
        <TextWrapper>
          <CardTitle className="cardT">{title}</CardTitle>

          <a href={fileSrc} download>
            <CardLink>
              {t("general.download")}
              <DownloadIcon />
            </CardLink>
          </a>
        </TextWrapper>
      </div>
    </CardWrapper>
  )
}

const CardWrapper = styled.div`
  transition: 0.3s;
  width: 100%;

  &:hover {
    h4 {
      color: ${themeGet("colors.primary")};
    }
    p {
      color: ${themeGet("colors.title")};
    }
    h6 {
      // transform: translateX(-10%);
      &:after {
        opacity: 1;
        width: 10%;
      }
      &:before {
        width: 0;
      }
    }
    img {
      transform: scale(1.05);
      opacity: 0.8;
    }
    .textWrapper {
      .cardL {
        justify-content: space-between;
        color: $colorsprimary !important;

        span {
          opacity: 1;
        }

        .iconWrapper {
          width: 100px;
          overflow: hidden;
          .svgRow {
            margin-left: 0px !important;
          }
        }
      }
    }
  }
  .imgWrapper {
    background-color: #ccc;
    width: 100%;
    height: 300px;
    overflow: hidden;
    background-color: #001f58;
    border-radius: 15px;
    position: relative;

    .img {
      width: 100%;
      height: 100%;
      object-fit: cover;
      transition: 0.5s ease;

      &.asset {
        object-fit: contain;
      }
    }

    @media (max-width: 1024px) {
      height: 200px;
    }
  }
`
const CardLink = styled.h6`
  width: 100%;
  color: ${themeGet("colors.primary")};
  margin-top: 10px;
  display: flex;
  align-items: center;
  transition: 0.3s ease;
  @media (max-width: 600px) {
    justify-content: flex-start;
  }
`
const CardTitle = styled.h4`
  font-weight: 700;
  margin-bottom: 10px;
  transition: 0.3s ease;
`
const TextWrapper = styled.div`
  padding: 2rem;
  padding-right: 0;

  padding: 30px 0px 30px 0px !important;

  .cardT {
    margin-top: 0;
    // height: 50px;
  }

  .cardC {
    font-size: 1rem;
    line-height: 1.5rem;
    margin-top: 0px;
    font-weight: normal;
  }

  .cardD {
    font-size: 1rem;
    color: #ccc;
    margin-top: 0px;
    margin-bottom: 0px;
  }

  .cardL {
    justify-content: space-between;
    color: #ccc;
    margin-top: 10px;
    @media (max-width: 600px) {
      font-size: 1rem;
    }

    span {
      font-weight: 300;
      opacity: 0;
      transition: 0.3s;
      color: rgba(255, 255, 255, 0.732);
      @media (max-width: 600px) {
        opacity: 1;
      }
    }

    .iconWrapper {
      width: 100px;
      overflow: hidden;
      position: relative;
      display: flex;

      .svgRow {
        flex: 0 0 360px;
        margin-left: -240px;
        transition: 0.3s;
        position: relative;
        bottom: 0;
      }
    }
  }

  @media (max-width: 1024px) {
    padding: 2rem 0;
  }
`
